import Quill from 'quill';

const Image = Quill.import('formats/image');

const ATTRIBUTES = [
  'alt',
  'height',
  'width',
  'class',
  'style'
];

class CustomImage extends Image {
  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      const copy = { ...formats };

      if (domNode.hasAttribute(attribute)) {
        copy[attribute] = domNode.getAttribute(attribute);
      }

      // if (attribute === 'style' && (!!copy.width && !!copy.height)) {
      //   if (copy[attribute]) {
      //     copy[attribute] += ` aspect-ratio: ${copy.width}/${copy.height}`;
      //   }
      // }

      return copy;
    }, {});
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

export default CustomImage;
